/**
 * 人工下载相关 API
 */
import { request, requestNew } from "../utils/request";
import serviceInterface from "../api/serviceInterface";

/**
 * 提交工单
 * @param params {materialIds: [], webType: string}
 * @returns {Promise}
 */
export const submitWorkOrder = (params) => {
  return requestNew({
    url: serviceInterface.workOrder.submit,
    params: params,
    isShow: "1",
  });
};

/**
 * 查询工单状态
 * @param params {workOrderId: string} 不传则查询所有工单
 * @returns {Promise}
 */
export const queryWorkOrderStatus = (params) => {
  return request({
    url: serviceInterface.workOrder.query,
    params: params,
  });
};

/**
 * 取消工单
 * @param params {workOrderId: string}
 * @returns {Promise}
 */
export const cancelWorkOrder = (params) => {
  return requestNew({
    url: serviceInterface.workOrder.cancel,
    params: params,
    isShow: "1",
  });
};
